<script></script>

<div class="main">
    <div class="center">
        <div class="title">
            INTEGRATION
        </div>
        <div class="img-wrapper">
            <img width="100%" height="100%" src="images/web3_pages/integration.png" alt="integration">
        </div>
        <div class="detail">
            Each video game created through our platform has native Web3 integration.
        </div>
    </div>
</div>

<style>
    .main{
        width: 33.854vw;
        height: 47.917vw;
        background-color: #ffffff;
        box-shadow: -0.208vw 0.208vw 0.417vw rgba(0, 0, 0, 0.5);
        border-radius: 2.083vw;
        position: relative;
    }
    .center{
        font-family: 'Montserrat';
        position: absolute;
        top: 5.451vw;
        font-style: normal;
        width: 100%;
        color: #FF007F;
    }
    .title{
        font-weight: 900;
        font-size: 2.604vw;
        line-height: 74.5%;
        text-align: center;
    }
    .img-wrapper{
        position: absolute;
        top: 5.889vw;
        left: 1.771vw;
        width: 31.302vw;
        height: 17.24vw;
    }
    .img-wrapper img{
        pointer-events: none;
    }
    .detail{
        width: 18.451vw;
        text-align: center;
        font-weight: 700;
        font-size: 1.563vw;
        line-height: 100%;
        position: absolute;
        top: 31.406vw;
        left: 0;
        right: 0;
        margin: auto;
    }
</style>